module.exports = __webpack_public_path__ + "static/media/example-2.23c77950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Harvey/example-2.jpg
// module id = 305
// module chunks = 0